import { FC } from 'react'
import { Box } from '@mui/material'
import theme from 'theme'

const FilterLoadingOverlay: FC = () => {
  // Calculate number of rows based on available height (64px per row + 4px gap)
  const rowCount = Math.ceil((window.innerHeight - 339) / 68)

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 49, // Header height
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'transparent',
        zIndex: 10,
        overflow: 'hidden'
      }}
    >
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            height: 64,
            borderRadius: theme.attributes.borderRadius.tertiary,
            backgroundColor: rowIndex % 2 === 0 ? theme.colors.primaryDark : theme.colors.legacy261f252,
            border: `1px solid ${theme.colors.devicesRowBorder}`,
            mb: '4px',
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.6 },
              '100%': { opacity: 1 }
            },
            animation: 'pulse 1.5s ease-in-out infinite'
          }}
        />
      ))}
    </Box>
  )
}

export default FilterLoadingOverlay
